import InputEntity, { PHONE_MASK } from '@/lib/formFactory/inputEntity';
import ImageEntity from '@/lib/formFactory/imageEntity';
import RadioEntity from '@/lib/formFactory/radio/entity';
import AutocompleteEntity from '@/lib/formFactory/autocomplete/entity';

import { PatientModel } from '@/types/models/patients';

export default class EntityModel {
    model: PatientModel;

    constructor() {
        const firstname = new InputEntity('firstname');
        firstname.setTitle('Имя')
        firstname.setRequired(true);

        const surname = new InputEntity('surname');
        surname.setTitle('Фамилия')
        surname.setRequired(true);

        const patronymic = new InputEntity('patronymic');
        patronymic.setTitle('Отчество')
        patronymic.setRequired(true);

        const email = new InputEntity('email');
        email.setTitle('Email')

        const phone = new InputEntity('phone');
        phone.setTitle('Телефон');
        phone.setRequired(true);
        phone.setMask(PHONE_MASK);

        const gender = new RadioEntity('gender')
            .setTitle('Пол')
            .setItems([
                {
                    label: 'Мужской',
                    value: 'male',
                },
                {
                    label: 'Женский',
                    value: 'female',
                }
            ])
            .setDefaultValue('')

        const birth = new InputEntity('birth');
        birth.setTitle('Дата рождения')
        birth.setMask({
            inputFormat: 'dd.mm.yyyy',
            outputFormat: 'dd.mm.yyyy',
            placeholder: 'дд.мм.гггг',
            alias: 'datetime'
        });

        const parent = new AutocompleteEntity('parent')
            .setTitle('Ответственное лицо')
            .setSettings({
                filterName: 'fullName',
                entityName: 'patients',
            })

        const city = new AutocompleteEntity('city')
            .setTitle('Город')
            .setSettings({
                filterName: 'name',
                entityName: 'cities/search',
                formatParams: (search: string) =>  `q=${search}`,
            })

        const address = new InputEntity('address');
        address.setTitle('Адрес');

        const apartment = new InputEntity('apartment');
        apartment.setTitle('Квартира');

        const photo = new ImageEntity('photo');
        photo.setTitle('Фотография');
        photo.setKey('photo-input');

        this.model = {
            // name
            firstname: firstname.entity[firstname.entityName],
            surname: surname.entity[surname.entityName],
            patronymic: patronymic.entity[patronymic.entityName],

            // info
            phone: phone.entity[phone.entityName],
            email: email.entity[email.entityName],
            birth: birth.entity[birth.entityName],
            gender: gender.entity,
            parent: parent.entity,

            // address
            city: city.entity,
            address: address.entity[address.entityName],
            apartment: apartment.entity[apartment.entityName],

            photo: photo.entity[photo.entityName],
        };
    }
}
